// Inquiry.js

import React, { Component } from 'react';
import { Button, Form, Table } from 'react-bootstrap';
import Config from '../Config';
import ScrollArea from 'react-scrollbar';
import Modal from 'react-awesome-modal';

import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import Column from 'react-virtualized/dist/commonjs/Table/Column';
import GTable from 'react-virtualized/dist/commonjs/Table';
import SortDirection from 'react-virtualized/dist/commonjs/Table/SortDirection';
import SortIndicator from 'react-virtualized/dist/commonjs/Table/SortIndicator';
import styles from './Table.css';

class ListItem extends Component {
    static defaultProps = {
        item: null,
        enable: false,
        onPress: () => { },
    }
    constructor(props) {
        super(props);
        this.state = {
            answervisible: false
        };
    }

    handleRowClick = () => {
        this.props.onPress(this.props.item);
        // alert(item);
        // this.setState({answervisible:true});
        event.preventDefault();
    }
    render() {
        return (
            <tr onClick={this.handleRowClick}>
                <td>{this.props.item.ID}</td>
                <td>{this.props.item.EMAIL}</td>
                <td>{this.props.item.TITLE}</td>
                <td>{this.props.item.QUESTION}</td>
                <td>{this.props.item.ANSWER ? "OK" : "NO"}</td>
                <td>{this.props.item.REG_DATE}</td>
            </tr>
        );
    }
};

const searchitems = ['CONTENT', 'WRITER', 'PCODE'];
export default class MediaReply extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '제목을 입력하세요.',
            content: '내용을 입력하세요.',
            country: 'KR',
            lang: 'ko',
            results: [],
            rowlist: [],
            rowCount: 0,
            answervisible: false,
            item: { TITLE: '', QUESTION: '' },
            searchitem: searchitems[0],
            searchText: '',
        };
    }

    handleChange = (event) => {
        var item = this.state.item;
        item.TITLE = event.target.value;
        this.setState({ item: item });
    }

    handleChangeContent = (event) => {
        var item = this.state.item;
        item.QUESTION = event.target.value;
        this.setState({ item: item });
    }

    handleChangeSearchItem = (event) => {
        this.setState({ searchitem: event.target.value });
    }

    fetchData(address, params, callback, revalidate = false, cbError) {

        var chcheoption = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (revalidate) {
            // chcheoption['Cache-Control'] = 'must-revalidate';
        }

        fetch(`${Config.Server}/${address}`, {
            // mode: 'no-cors',
            method: 'POST',
            headers: chcheoption,
            body: JSON.stringify(params)
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);
                if (callback)
                    callback(responseJson.result, responseJson.count);
            })
            .catch((error) => {
                console.error(error);
                cbError(error);
            });
    }


    updatereplay = (erase) => {
        this.fetchData('reply/updatereplay', {
            ID: this.state.item.ID,
            ERASED: erase
        }, (result, count) => {
            console.log('updatereplay=', count);
            this.componentDidMount();
        }, true);
    }

    handleErase = (event) => {

        this.updatereplay(1);

        console.log('handleErase');
        this.setState({ answervisible: false });
        event.preventDefault();
    }

    handleRecov = (event) => {

        this.updatereplay(0);

        console.log('handleRecov');
        this.setState({ answervisible: false });
        event.preventDefault();
    }

    handleRowClick = (event) => {
        var item = event.rowData;
        console.log(item);
        // alert(item);
        var edititem = { ...item };
        edititem.TITLE = "[1:1 문의 답신]" + item.TITLE;
        edititem.QUESTION = "[질문 내용]\n" + item.QUESTION + "\n[답신 내용]\n";

        this.setState({ item: edititem });
        this.setState({ answervisible: true });
        event.preventDefault();
    }

    componentDidMount() {
        this.fetchData('reply/mediareply', {
        }, (result, count) => {
            console.log('count=', count);
            this.setState({ rowlist: result, results: result })
            this.setState({ rowCount: result.length })
        }, true);
    }

    handleScroll(scrollData) {
        console.log(scrollData);
    }

    handleClose = () => {
        console.log('handleClose');
        this.setState({ answervisible: false });
    }

    handleSearchChange = (event) => {
        event.preventDefault(); // form의 기본 제출 동작을 방지합니다.
        var newValue = this.state.searchText;
        newValue = event.target.value;
        this.setState({ searchText: newValue }, () => {
            this.onClickSearch();
        });
    };

    onClickSearch = () => {
        if (this.state.searchText.trim().length < 1) {
            this.setState({ rowlist: this.state.results });
        } else {
            this.setState({ rowlist: this.state.results.filter(item => item[this.state.searchitem].includes(this.state.searchText.trim())) });
        }
    }

    _noRowsRenderer() {
        return <div>No rows</div>;
    }

    _onScrollToRowChange(event) {
        const { rowCount } = this.state;
        let scrollToIndex = Math.min(
            rowCount - 1,
            parseInt(event.target.value, 10),
        );

        if (isNaN(scrollToIndex)) {
            scrollToIndex = undefined;
        }

        this.setState({ scrollToIndex });
    }

    _rowClassName({ index }) {
        if (index < 0) {
            return "headerRow";
        } else {
            return index % 2 === 0 ? "evenRow" : "oddRow";
        }
    }

    render() {
        let scrollbarStyles = { borderRadius: 5 };
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box">
                                <div className="box-header with-border">
                                    <table>
                                        <tr>
                                            <td>
                                                <h3 className="box-title">댓글 리스트</h3>
                                            </td>
                                            <td width="20"></td>
                                            <td>
                                                <Form style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <Form.Group style={{ width: 170 }} controlId="exampleForm.ControlSelect1">
                                                        <Form.Control as="select" value={this.state.searchitem} onChange={this.handleChangeSearchItem}>
                                                            {searchitems.map((item, index) =>
                                                                <option>{item}</option>
                                                            )}
                                                        </Form.Control>
                                                    </Form.Group>
                                                    <Form.Control type="title" value={this.state.searchText} onChange={this.handleSearchChange} placeholder={this.state.searchitem + "을 입력하세요."} />
                                                    <Button variant="primary" onClick={this.onClickSearch}>검색</Button>
                                                </Form>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div className="box-body" style={{ margin: 20 }}>
                                    <div className="row">
                                        <AutoSizer disableHeight>
                                            {({ width }) => (
                                                <GTable
                                                    ref="Table"
                                                    headerClassName={'headerColumn'}
                                                    onRowClick={this.handleRowClick}
                                                    headerHeight={30}
                                                    height={800}
                                                    noRowsRenderer={this._noRowsRenderer}
                                                    overscanRowCount={10}
                                                    rowClassName={this._rowClassName}
                                                    rowHeight={40}
                                                    rowGetter={({ index }) => this.state.rowlist[index]}
                                                    rowCount={this.state.rowlist.length}
                                                    scrollToIndex={this.state.scrollToIndex}
                                                    width={width}>
                                                    <Column
                                                        width={100}
                                                        disableSort
                                                        label="#"
                                                        dataKey="ID"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={100}
                                                        disableSort
                                                        label="PCODE"
                                                        dataKey="PCODE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={60}
                                                        disableSort
                                                        label="CLIP"
                                                        dataKey="CLIP"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={300}
                                                        disableSort
                                                        label="작성자"
                                                        dataKey="WRITER"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={600}
                                                        disableSort
                                                        label="내용"
                                                        dataKey="CONTENT"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={100}
                                                        disableSort
                                                        label="신고"
                                                        dataKey="REPORTS"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={50}
                                                        disableSort
                                                        label="삭제"
                                                        dataKey="ERASED"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData ? '삭제' : ''}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={200}
                                                        disableSort
                                                        label="등록일"
                                                        dataKey="REG_DATE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                </GTable>
                                            )}
                                        </AutoSizer>
                                    </div>
                                    <div className="row">
                                        <Modal visible={this.state.answervisible} width="80%" effect="fadeInUp" onClickAway={() => this.handleClose()}>
                                            <div style={{ margin: 20 }}>
                                                <h2>댓글</h2>
                                                <Form>
                                                    <Form.Group controlId="exampleForm.ControlInput1">
                                                        <Form.Label>PCODE</Form.Label>
                                                        <Form.Control type="title" placeholder="제목을 입력하세요." value={this.state.item.PCODE} onChange={this.handleChange} />
                                                    </Form.Group>
                                                    <Form.Group controlId="exampleForm.ControlInput1">
                                                        <Form.Label>CLIP</Form.Label>
                                                        <Form.Control type="title" placeholder="제목을 입력하세요." value={this.state.item.CLIP} onChange={this.handleChange} />
                                                    </Form.Group>
                                                    <Form.Group controlId="exampleForm.ControlTextarea1">
                                                        <Form.Label>댓글 내용</Form.Label>
                                                        <Form.Control as="textarea" rows="10" value={this.state.item.CONTENT} onChange={this.handleChangeContent} />
                                                    </Form.Group>
                                                    {this.state.item.ERASED ?
                                                        <Button variant="primary" onClick={this.handleRecov}>삭제 취소</Button> :
                                                        <Button variant="primary" onClick={this.handleErase}>댓글 삭제</Button>
                                                    }
                                                </Form>
                                                <div style={{ height: 5 }}></div>
                                                <Button variant="primary" onClick={this.handleClose}>Close</Button>
                                            </div>
                                        </Modal>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// src/components/MediaReply.js